import { fetchData } from 'Utils/fetch-data';
import type { OptionalCourseI, OptionalScopeT } from 'types';

const OPTIONAL_COURSES_ENDPOINT = '/courses/optional';

/**
 * Trae el catálogo de cursos publicados con su marca de opcional.
 * En error devuelve un arreglo vacío para que la pantalla no reviente.
 */
export const getOptionalCourses = async (): Promise<{ data: OptionalCourseI[]; error: string | null }> => {
  const response = await fetchData<OptionalCourseI[]>(OPTIONAL_COURSES_ENDPOINT, { method: 'GET' });

  if (response.error !== null || response.data === null) {
    return { data: [], error: response.error ?? 'FETCH_ERROR' };
  }

  return { data: response.data, error: null };
};

/**
 * Marca o desmarca cursos como opcionales en lote.
 *
 * @param courses - Pares `{ id, value }`; `value` en true marca, en false desmarca.
 *   `scope` solo aplica al marcar: ausente equivale a `'all'`. La pantalla en
 *   lote no lo manda; el switch de la configuración del curso manda `'members'`.
 */
export const setOptionalCourses = async (
  courses: { id: string; value: boolean; scope?: OptionalScopeT }[]
): Promise<{ error: string | null }> => {
  const response = await fetchData<{ updated: number }>(OPTIONAL_COURSES_ENDPOINT, {
    method: 'PATCH',
    data: { courses },
  });

  return { error: response.error };
};
